import { gql } from "@apollo/client";

export default gql`
  mutation RatePlanCreateMutation(
    $input: [RatePlanCreateInput!]!
    $replaceAll: Boolean
  ) {
    RatePlanCreate(input: $input, replaceAll: $replaceAll) {
      id
      message
      status
    }
  }
`;
